import { urlsWrapper, urls } from 'config';
import { createSelector } from 'reselect';
import { createAction } from 'redux-actions';
import { combineReducers } from 'redux';

import { commonGet } from './api';
import {
  saveData,
  createCommonListConstants,
  createCommonListReducer,
} from './utils';

// Старая логика
const oldConstants = createCommonListConstants('DIVISION_GROUPS');
export const oldReducer = createCommonListReducer(oldConstants);

// Новая логика
const newConstants = {
  SET_CUSTOMER: 'DIVISION_GROUPS_SET_CUSTOMER',
  RESET_CUSTOMERS: 'DIVISION_GROUPS_RESET_CUSTOMERS',
  SET_IS_PENDING: 'DIVISION_GROUPS_SET_IS_PENDING',
};

// reducers
const newDivisions = (state = null, action) => {
  switch (action.type) {
    case newConstants.SET_CUSTOMER:
      return { ...state, ...action.payload };
    case newConstants.RESET_CUSTOMERS:
      return null;
    default:
      return state;
  }
};

const newIsPending = (state = false, action) => {
  switch (action.type) {
    case newConstants.SET_IS_PENDING:
      return action.payload;
    default:
      return state;
  }
};

const newReducer = combineReducers({
  divisions: newDivisions,
  isPending: newIsPending,
});

// Объединяем редьюсеры
export default combineReducers({
  old: oldReducer,
  new: newReducer,
});

// Старые actions
export function getDivisionGroups() {
  return saveData(
    urlsWrapper('divisionGroups'),
    oldConstants.SET_LIST,
    oldConstants.SET_IS_PENDING
  );
}

// Новые actions
export const resetCustomer = createAction(newConstants.RESET_CUSTOMERS);

export const getDivisionGroupsByCustomer = (customerId) => async (dispatch) => {
  dispatch(createAction(newConstants.SET_IS_PENDING)(true));
  try {
    const url = `${urls().customers}/${customerId}/divisiongroups`;
    const response = await commonGet({ url });
    dispatch(
      createAction(newConstants.SET_CUSTOMER)({ [customerId]: response.data })
    );
    return response;
  } finally {
    dispatch(createAction(newConstants.SET_IS_PENDING)(false));
  }
};

// Старые selectors
export const getDivisionsGroupsSelector = createSelector(
  [
    (state) => state.divisionGroups.old.list,
    (state) => state.divisionGroups.old.isPending,
  ],
  (list, isPending) => ({
    list,
    isPending,
  })
);

// Новые selectors
export const getDivisionGroupsByCustomerSelector = createSelector(
  [
    (state) => state.divisionGroups.new.divisions,
    (state) => state.divisionGroups.new.isPending,
  ],
  (divisions, isPending) => ({
    divisions,
    isPending,
  })
);
